var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentLinkOutlineOpt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.414 6.344a3 3 0 014.243 4.242l-2.121 2.121 1.414 1.415L19.071 12a5 5 0 00-7.07-7.07L9.878 7.05l1.414 1.415 2.121-2.121z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.243 9.172l-7.071 7.071-1.414-1.414 7.07-7.07 1.415 1.413z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.465 11.293l-2.121 2.122a3 3 0 104.242 4.242l2.121-2.12 1.415 1.413L12 19.072A5 5 0 114.93 12l2.12-2.122 1.415 1.415z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLinkOutlineOpt2);
export default __webpack_public_path__ + "388a0ac7ee53e432030574c812c7a957.svg";
export { ForwardRef as ReactComponent };